import Config from '../../../config/Config'
import { map, mergeMap, catchError, withLatestFrom } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import { jwtSelector } from '../../auth/selectors'
import { rootCatchError } from '../../../lib/Utils'
import * as actions from '../actions'

export const activateCampaignObservable = ([action, state]) => {
  const {
    retailerId,
    campaignId,
    facebookPageId,
    locations,
    radius = 15,
    adcreative_templates,
    businessId,
    fundingSources,
  } = action.payload
  const jwt = jwtSelector(state) || action.payload.jwt

  if (!jwt) {
    throw new Error('Non-existent JWT auth')
  }

  if (!retailerId) {
    throw new Error('Retailer ID required')
  }

  if (!campaignId) {
    throw new Error('Campaign ID required')
  }

  if (!facebookPageId) {
    throw new Error('Facebook Page ID required')
  }

  if (!locations) {
    throw new Error('Locations required')
  }

  const body = JSON.stringify({
    retailer_id: retailerId,
    business_id: businessId,
    funding_sources: fundingSources,
    channels: [
      {
        channel: 'facebook',
        customizations: {
          adcreative_templates,
          facebook_page_id: facebookPageId.toString(),
          geo_locations: {
            custom_locations: locations.map((x) => ({
              radius,
              latitude: parseFloat(x.latitude),
              longitude: parseFloat(x.longitude),
            })),
          },
        },
      },
    ],
  })

  const settings = {
    method: 'PUT',
    responseType: 'json',
    contentType: 'application/json',
    headers: {
      Authorization: jwt,
    },
    body,
    url: `${Config.SERVICE_BASE}/ad/v1/campaign/${campaignId}/activate`,
  }

  return ajax(settings).pipe(
    map((payload) => {
      return {
        type: actions.ACTIVATE_CAMPAIGN_FULFILLED,
        payload: {
          response: payload.response,
          campaignId,
        },
      }
    }),
    catchError((payload) => {
      return of({
        type: actions.ACTIVATE_CAMPAIGN_REJECTED,
        payload: {
          status: payload.status,
          response: payload.response,
          campaignId,
          retryPayload: actions.activateCampaign(action.payload),
        },
      })
    }),
  )
}

export const activateCampaignEpic = (action$, state$) => {
  return action$.pipe(
    ofType(actions.ACTIVATE_CAMPAIGN),
    withLatestFrom(state$),
    mergeMap(activateCampaignObservable),
    rootCatchError(actions.ACTIVATE_CAMPAIGN_REJECTED),
  )
}
